<template>
  <div class="ts-shadow-rounded ts-rounded-xl ts-overflow-hidden">
    <div class="ts-pb-2/3 ts-relative">
      <img
        class="ts-object-cover ts-h-full ts-w-full ts-absolute"
        src="@/assets/front/images/blog/1.jpg"
        alt
      />
    </div>
    <div class="ts-p-8">
      <h3 class="post-title ts-font-heading-font ts-text-2xl">
        <a
          href="#0"
          class="ts-text-heading-color hover:ts-no-underline hover:ts-text-heading-color"
        >Learn the Advantages of Playing Lottery...</a>
      </h3>
      <ul class="post-meta ts-flex ts-space-x-3 ts-text-base">
        <li>
          <a
            href="#0"
            class="ts-text-para-color ts-font-normal ts-font-robot hover:ts-no-underline hover:ts-text-para-color"
          >
            <span>BY</span>David Millward
          </a>
        </li>
        <li>
          <a
            href="#0"
            class="ts-text-para-color ts-font-normal ts-font-robot hover:ts-no-underline hover:ts-text-para-color"
          >
            <i class="fa fa-calendar"></i> 11 June 2018
          </a>
        </li>
      </ul>
      <p class="ts-mt-3 ts-leading-7 ts-text-para-color ts-text-base">
        Do you play lotto regularly, yet,
        the necessity of visiting an outlet each time you want to purchase
        a Lotto ticket is uncomfortable...
      </p>
      <a
        @click.prevent="viewDetail"
        href="#0"
        class="blog-btn ts-text-para-color ts-border ts-border-gray-400 ts-px-8 ts-py-2 ts-rounded-full ts-mt-8 ts-inline-block ts-capitalize ts-font-semibold ts-text-base ts-font-robot hover:ts-text-white hover:ts-bg-maincolor hover:ts-no-underline"
      >read more</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['resource'],
  methods: {
    viewDetail(){
      this.$router.push({ name: 'front-news-show', params: { id: 1 }})
    }
  }
}
</script>